(() => {
  'use strict';
  const configNode = document.getElementById('FultonsManualCheckoutData');
  const core = window.FultonsManualCheckoutCore;
  if (!configNode || !core || window.FultonsManualCheckout) return;
  let data;
  try { data = JSON.parse(configNode.textContent); } catch { return; }
  const records = new WeakMap();
  let indexPromise;
  const manifestPromises = new Map(), chunkPromises = new Map();
  const getJSON = async url => {
    const response = await fetch(new URL(url, location.origin), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('manifest');
    return response.json();
  };
  const cachedJSON = (cache, key, url, refresh) => {
    if (refresh || !cache.has(key)) cache.set(key, getJSON(url).catch(error => { cache.delete(key); throw error; }));
    return cache.get(key);
  };
  const loadManifest = async (input, refresh = false) => {
    const index = await (indexPromise ||= getJSON(data.manifestIndexUrl).catch(error => { indexPromise = null; throw error; }));
    const configs = index.productId === data.productId ? index.configurations.filter(c => c.label === input.configurationLabel && c.base === input.base && c.size === input.size && c.footstool === input.footstool) : [];
    if (configs.length !== 1 || !data.manifestUrls[configs[0].code]) throw new Error('selection');
    const code = configs[0].code, childUrl = data.manifestUrls[code];
    const child = await cachedJSON(manifestPromises, code, childUrl, refresh);
    if (child.configuration?.code !== code) throw new Error('chunk-index');
    const key = core.signature(input, code), name = child.selectionChunks?.[key];
    if (typeof name !== 'string' || !/^fultons-manual-checkout-\d{7}-c\d{2}\.json$/.test(name) || !name.startsWith('fultons-manual-checkout-' + code + '-')) throw new Error('unmapped-selection');
    // Retain Shopify's genuine per-asset version; custom query names do not bust its CDN cache.
    const declaredChunkUrl = data.selectionChunkUrls?.[name];
    if (typeof declaredChunkUrl !== 'string') throw new Error('unmapped-selection');
    const chunkUrl = new URL(declaredChunkUrl, location.origin);
    const expectedChunkUrl = new URL(name, new URL(childUrl, location.origin));
    if (chunkUrl.origin !== expectedChunkUrl.origin || chunkUrl.pathname !== expectedChunkUrl.pathname || !chunkUrl.searchParams.get('v')) throw new Error('unmapped-selection');
    const chunk = await cachedJSON(chunkPromises, name + ':' + child.revision, chunkUrl, refresh);
    const manifest = core.joinChunk(child, chunk, key);
    if (!manifest) throw new Error('missing-wrong-or-stale-chunk');
    return manifest;
  };
  const orderDetails=record=>record?{model:data.productTitle,configuration:record.configuration,covering:record.covering,...(record.wood?{wood:record.wood}:{}),...(record.configurationBase==='Cross'?{legColour:record.legColour}:{}),dimensions:record.dimensions}:{};
  const getNative = async (record, signal) => {
    const url = new URL(record.childUrl, location.origin);
    url.searchParams.set('variant', record.variantId);
    const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview&&/^\d+$/.test(preview))url.searchParams.set('preview_theme_id',preview);
    url.searchParams.set('section_id', 'fultons-manual-purchase-state');
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal });
    if (!response.ok) throw new Error('native');
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const element = page.querySelector('[data-fultons-manual-native]');
    if (!element) throw new Error('native');
    return JSON.parse(element.textContent);
  };
  function panelFor(root) {
    let panel = root.querySelector('[data-manual-purchase]');
    if (panel) return panel;
    const target = root.querySelector('[data-seating-dropdowns] .fsd-enquire');
    const template = document.getElementById('FultonsManualPurchaseTemplate');
    if (!target || !template) return null;
    target.before(template.content.cloneNode(true));
    root.dataset.manualPurchaseMounted = 'true';
    target.setAttribute('data-manual-enquiry', '');
    return root.querySelector('[data-manual-purchase]');
  }
  function display(root, match, message = '') {
    const panel = panelFor(root);
    if (!panel) return;
    const manifest = records.get(root)?.manifest;
    panel.hidden = !manifest?.onlineEnabled;
    const form = panel.querySelector('form');
    form.querySelector('[name="id"]').value = match?.canCheckout ? match.variantId : '';
    form.querySelector('[name="id"]').disabled = !match?.canCheckout;
    form.querySelector('[type="submit"]').disabled = !match?.canCheckout;
    const quantity = form.querySelector('[name="quantity"]');
    quantity.disabled = !match?.canCheckout;
    if (match?.quantityRule) {
      const rule = match.quantityRule;
      quantity.min = String(rule.min);
      quantity.step = String(rule.increment);
      if (rule.max === null) quantity.removeAttribute('max');
      else quantity.max = String(rule.max);
      if (!core.quantityAllowed(Number(quantity.value), rule)) quantity.value = String(rule.min);
    }
    panel.querySelector('[data-manual-status]').textContent = message || (match?.reason === 'order-limit' ? data.strings.orderLimit : '');
    const details = panel.querySelector('[data-manual-order-summary]');
    details.replaceChildren();
    for (const [key, value] of Object.entries(orderDetails(match?.record))) {
      if (!data.labels[key]) continue;
      const dt = document.createElement('dt'), dd = document.createElement('dd');
      dt.textContent = data.labels[key]; dd.textContent = value; details.append(dt, dd);
    }
    for (const field of ['delivery', 'returns', 'payment']) panel.querySelector('[data-manual-' + field + ']').textContent = manifest?.commercial?.[field] || '';
    panel.querySelector('[data-manual-delivery-short]').textContent = manifest?.commercial?.deliveryShort || '';
    if (/^\/(?!\/)/.test(manifest?.commercial?.accessGuideUrl || '')) panel.querySelector('[data-manual-access-guide]').href = manifest.commercial.accessGuideUrl;
    root.dataset.manualCheckoutReady = String(Boolean(match?.canCheckout));
  }
  function reviewSelection(root, match, quantity, state) {
    const dialog = panelFor(root).querySelector('[data-manual-review]');
    if (typeof dialog?.showModal !== 'function') throw new Error('review');
    const order = orderDetails(match.record);
    dialog.querySelector('[data-manual-review-model]').textContent = order.model || '';
    dialog.querySelector('[data-manual-review-returns]').textContent=state.manifest?.commercial?.returns||'';
    const details = dialog.querySelector('[data-manual-review-summary]');
    details.replaceChildren();
    for (const key of ['configuration', 'covering', 'wood', 'legColour', 'dimensions', 'quantity']) {
      const value = key === 'quantity' ? String(quantity) : order[key];
      if (!value || !data.labels[key]) continue;
      const dt = document.createElement('dt'), dd = document.createElement('dd');
      dt.textContent = data.labels[key]; dd.textContent = value; details.append(dt, dd);
    }
    dialog.querySelector('[data-manual-review-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }).format(match.pricePence * quantity / 100);
    return new Promise(resolve => {
      const confirm = dialog.querySelector('[data-manual-review-confirm]');
      const edit = dialog.querySelector('[data-manual-review-edit]');
      const finish = accepted => {
        confirm.removeEventListener('click', approve);
        edit.removeEventListener('click', cancel);
        dialog.removeEventListener('cancel', cancel);
        dialog.removeEventListener('close', cancel);
        state.cancelReview = null;
        if (dialog.open) dialog.close();
        resolve(accepted);
      };
      const approve = () => finish(true);
      const cancel = event => { event?.preventDefault(); finish(false); };
      state.cancelReview = cancel;
      confirm.addEventListener('click', approve);
      edit.addEventListener('click', cancel);
      dialog.addEventListener('cancel', cancel);
      dialog.addEventListener('close', cancel);
      dialog.showModal();
      dialog.querySelector('h2').focus();
    });
  }
  async function updateSelection(input, root) {
    if (!root || input?.productId !== data.productId) return;
    let state = records.get(root);
    if (!state) { state = { revision: 0, busy: false }; records.set(root, state); }
    state.cancelReview?.();
    state.abort?.abort();
    state.abort = new AbortController();
    state.input = structuredClone(input);
    state.revision += 1;
    const revision = state.revision;
    state.match = null;
    if ((input.footstool === 'integrated' || input.base === 'Power Leg + Back') && !core.complete({ ...input, pricePence: core.pricePence(input.priceGbp), rrpPence: core.pricePence(input.rrpGbp) })) {
      state.manifest = null;
      display(root, null);
      return;
    }
    display(root, null, data.strings.checking);
    try {
      const source = await loadManifest(input);
      if (!root.isConnected || state.revision !== revision) return;
      state.manifest = source;
      const selection = { ...input, pricePence: core.pricePence(input.priceGbp), rrpPence: core.pricePence(input.rrpGbp) };
      const match = core.find(source, selection);
      if (!match.matched) { display(root, match); return; }
      const native = await getNative(match.record, state.abort.signal);
      if (!root.isConnected || state.revision !== revision) return;
      state.match = core.resolve(source, selection, native);
      display(root, state.match);
    } catch (error) {
      if (state.revision === revision && error.name !== 'AbortError') display(root, null, data.strings.unavailable);
    }
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-manual-purchase-form]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const root = form.closest('.catalogue-proof,.pdp-refined'), state = root && records.get(root);
    if (!state || state.busy || !form.reportValidity()) return;
    state.busy = true;
    const revision = state.revision, quantity = Number(form.elements.quantity.value);
    let manifest = state.manifest;
    const selection = { ...state.input, pricePence: core.pricePence(state.input.priceGbp), rrpPence: core.pricePence(state.input.rrpGbp) };
    display(root, null, data.strings.checking);
    let cartAttempted = false;
    try {
      manifest=await loadManifest(state.input,true);
      if(state.revision!==revision||!root.isConnected)throw new Error('changed');
      const match = core.find(manifest, selection);
      if (!match.matched) throw new Error('selection');
      let native = await getNative(match.record);
      let resolved = core.resolve(manifest, selection, native);
      if (state.revision !== revision || !root.isConnected || data.currency !== 'GBP') throw new Error('changed');
      if (!resolved.canCheckout || !core.quantityAllowed(quantity, resolved.quantityRule)) throw new Error('selection');
      const reviewed = resolved, reviewToken=core.reviewToken(resolved,quantity,revision);
      if (!await reviewSelection(root, reviewed, quantity, state)) {
        if (state.revision === revision && root.isConnected) {
          display(root, state.match);
          form.querySelector('[type="submit"]').focus();
        }
        return;
      }
      manifest=await loadManifest(state.input,true);
      if(state.revision!==revision||!root.isConnected)throw new Error('changed');
      const cartResponse = await fetch(data.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('cart-check');
      const currentCart = await cartResponse.json();
      if (!core.cartWithinLimit(currentCart, resolved.pricePence, quantity)) throw new Error('order-limit');
      if (state.revision !== revision || !root.isConnected || Number(form.elements.quantity.value) !== quantity) throw new Error('changed');
      native = await getNative(match.record);
      resolved = core.resolve(manifest, selection, native);
      if (state.revision !== revision || !root.isConnected || Number(form.elements.quantity.value) !== quantity || !resolved.canCheckout || resolved.variantId !== reviewed.variantId || resolved.pricePence !== reviewed.pricePence) throw new Error('changed');
      if(!core.reviewStillValid(reviewToken,resolved,Number(form.elements.quantity.value),state.revision))throw new Error('changed');
      const body = core.payload(resolved, quantity, data.labels, manifest.commercial, {configuration:true,access:true});
      if (!body) throw new Error('selection');
      const finalMatch = core.resolve(manifest, selection, native);
      if (!finalMatch.canCheckout || finalMatch.variantId !== resolved.variantId || finalMatch.pricePence !== resolved.pricePence) throw new Error('changed');
      cartAttempted = true;
      const response = await fetch(data.cartAddUrl + '.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      });
      if (!response.ok) throw new Error('cart');
      const result = await response.json();
      const added = result.items?.[0];
      if (!added || String(added.variant_id) !== resolved.variantId || String(added.product_id) !== resolved.record.childProductId || added.price !== resolved.pricePence) {
        display(root, null, data.strings.checkBasket);
        return;
      }
      location.assign(data.cartUrl);
    } catch (error) {
      if (state.revision === revision) display(root, null, cartAttempted ? data.strings.checkBasket : error.message === 'order-limit' ? data.strings.orderLimit : data.strings.unavailable);
    } finally { state.busy = false; }
  }, true);
  const refresh = () => {
    const root = document.querySelector('#MainContent .catalogue-proof:not([hidden]),#MainContent .pdp-refined:not([hidden])');
    if (root?._fultonsManualSelection) updateSelection(root._fultonsManualSelection, root);
  };
  document.addEventListener('fultons:manual-selection', event => updateSelection(event.detail, event.target));
  window.addEventListener('pageshow', refresh);
  document.addEventListener('DOMContentLoaded', refresh, { once: true });
  window.FultonsManualCheckout = Object.freeze({ updateSelection });
  document.dispatchEvent(new CustomEvent('fultons:manual-checkout-ready'));
  refresh();
})();

